import React, { FC } from 'react';
import s from './WixLogo.scss';

export const WixLogo: FC<{ dataHook?: string }> = ({ dataHook }) => (
  <a data-hook={dataHook} href="/" className={s.logo}>
    <span className={s.hide}>wix.com</span>
  </a>
);
